import React, { useRef, useState } from "react";
import { RiAttachment2 } from "react-icons/ri";
import { sendEmailAPI } from "../api-services/sendEmail.api";
import { FiX } from "react-icons/fi";
import { API_URL } from "../api-services/Environment";

const EmailPage = () => {
  const fileInputRef = useRef(null);
  const shopUrl = window.location.href;
  const domain = new URL(shopUrl).host;

  const [state, setState] = useState({
    name: "",
    nameErr: "",
    email: "",
    emailErr: "",
    details: "",
    detailsErr: "",
    file: "",
  });
  const [loader, setLoader] = useState(false);
  const [showMsg, setShowMsg] = useState(false);

  const handleChange = (field, value) => {
    const _Inputs = state;
    const emailRegex = /\S+@\S+\.\S+/;

    if (field === "name") {
      _Inputs.nameErr = value ? "" : "Please Enter Name";
      _Inputs.name = value;
    } else if (field === "email") {
      _Inputs.emailErr = value
        ? !emailRegex.test(value)
          ? "Please Enter Valid Email"
          : ""
        : "Please Enter Email";
      _Inputs.email = value;
    } else if (field === "details") {
      _Inputs.detailsErr = value ? "" : "Please Enter details";
      _Inputs.details = value;
    } else if (field === "file") {
      _Inputs.file = value;
    }
    setState({ ...state, _Inputs });
  };

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files) {
      handleChange("file", files);
    }
  };

  const handleSubmit = () => {
    if (!state.name || !state.email || !state.details || state.emailErr) {
      setState({
        ...state,
        nameErr: !state.name ? "Please Enter Name" : "",
        emailErr: !state.email ? "Please Enter Email" : "",
        detailsErr: !state.details ? "Please Enter Details" : "",
      });
    } else {
      try {
        setLoader(true);
        const payload = {
          name: state.name,
          body: state.details,
          email: state.email,
          attach: state.file ? state.file[0] : null,
          shopID: domain === "localhost:3000" ? "sulopa.myshopify.com" : domain,
        };
        try {
          sendEmailAPI(payload).then((res) => {
            if (res.status === 201) {
              setLoader(false);
              setShowMsg(true);
              setState({
                ...state,
                email: "",
                name: "",
                details: "",
                file: "",
              });
              setTimeout(() => {
                setShowMsg(false);
              }, [1000]);
            } else {
              setLoader(false);
            }
          });
        } catch {}
      } catch {}
    }
  };

  return (
    <div
      style={{
        padding: 20,
        display: "flex",
        flexDirection: "column",
        fontSize: 16,
        color: "black",
        gap: 16,
        position: "relative",
      }}
    >
      {showMsg && (
        <div
          style={{
            position: "absolute",
            backgroundColor: "green",
            display: "flex",
            width: "84%",
            borderRadius: 4,
            padding: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: "white",
          }}
        >
          <label>Email has been sent</label>
          <button
            className="close-chat-btn"
            onClick={() => setShowMsg(false)}
            aria-label="Close Chat"
          >
            <FiX />
          </button>
        </div>
      )}

      <label>Information</label>

      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <input
          type="text"
          className="form-input"
          placeholder="Name"
          value={state.name}
          onChange={(e) => handleChange("name", e.target.value)}
          style={{ marginBottom: 0 }}
        />
        <label style={{ color: "#ff4c4c", fontSize: 12, marginLeft: 4 }}>
          {state.nameErr}
        </label>
        <input
          type="email"
          placeholder="Email"
          value={state.email}
          onChange={(e) => handleChange("email", e.target.value)}
          className="form-input"
          style={{ marginBottom: 0 }}
        />
        <label style={{ color: "#ff4c4c", fontSize: 12, marginLeft: 4 }}>
          {state.emailErr}
        </label>
      </div>

      <label>Details</label>
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <textarea
          placeholder="Please describe your query in detail"
          value={state.details}
          onChange={(e) => handleChange("details", e.target.value)}
          className="form-input"
          rows={5}
          style={{ marginBottom: 0, resize: "none", height: "auto" }}
        />
        <label style={{ color: "#ff4c4c", fontSize: 12, marginLeft: 4 }}>
          {state.detailsErr}
        </label>
      </div>

      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 4,
            marginTop: 16,
            fontSize: 14,
            cursor: "pointer",
          }}
          onClick={handleClick}
        >
          <RiAttachment2 />
          <label style={{ cursor: "pointer" }}>
            {state.file ? state.file[0].name : "Attach File"}
          </label>
        </div>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </div>

      {loader ? (
        <img
          src={`${API_URL}common/gif/loader.gif.gif`}
          alt="loader"
          style={{
            right: 18,
            width: 35,
            height: 35,
            display: "flex",
            justifyContent: "center",
            alignSelf: "center",
          }}
        />
      ) : (
        <button className={`form-button`} onClick={handleSubmit}>
          <span className="button-text">Submit</span>
        </button>
      )}
    </div>
  );
};

export default EmailPage;
